import { BlockStack, Button, Icon, IndexTable, InlineStack, LegacyCard, Text, Tooltip } from '@shopify/polaris';
import { InfoMinor, StatusActiveMajor } from '@shopify/polaris-icons';
import { t } from 'i18next';
import React from 'react'

const MarketingComparison = () => {
  const activeMajor = <Icon source={StatusActiveMajor} tone='success' />;
  const marketingServicesData = [
    {
      id: '01',
      services: t("24/7 Free Support"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '02',
      services: t("Support Response Time"),
      enhanced: t("3-6 hours"),
      premium: t("2-4 hours"),
      elite: t("1-2 hours")
    },
    {
      id: "03",
      services: t("Support Channels"),
      enhanced: <Text as='span'>{t("Email, Chats, WhatsApp, Slack")}</Text>,
      premium: <Text as='span'>{t("Email, Chats, WhatsApp, Slack")}</Text>,
      elite: <Text as='span'>{t("Email, Chats, WhatsApp, Slack")}</Text>
    },
    {
      id: '04',
      services: t("Dedicated Account Manager (AM)"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '05',
      services: t("Account Monitoring"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '06',
      services: t("Onboarding Assistance with AM"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '07',
      services: t("Technical POC for Issue Resolutions"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '08',
      services: <InlineStack gap={"050"}>
        <Text as='span' variant='bodyMd' fontWeight='medium'>{t("Product Upload Support")}</Text>
        <Tooltip content={t("Any overheads will come at an added cost based on your business needs.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
      </InlineStack>,
      enhanced: t("Up to 10 SKUs (one-time)"),
      premium: t("Up to 30 SKUs/month"),
      elite: t("Up to 30 SKUs/month"),
      withTooltip: true
    },
    {
      id: '09',
      services: t("Listing Optimization"),
      enhanced: "-",
      premium: t("Up to 10 SKUs"),
      elite: <BlockStack>
        <span>{t("Up to 30 SKUs ")}</span>
        <span>({t("with Sponsored Ads")})</span>
      </BlockStack>
    },
    {
      id: '10',
      services: <InlineStack gap={"050"}>
        <Text as='span' variant='bodyMd' fontWeight='medium'>{t("A+ Content / EBC Content")}</Text>
        <Tooltip content={t("To promote brand presence on Amazon")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
      </InlineStack>,
      enhanced: "-",
      premium: "-",
      elite: t("Up to 5 SKUs"),
      withTooltip: true
    },
    {
      id: '11',
      services: t("Account Health Check"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '12',
      services: <InlineStack gap={"050"}>
        <Text as='span' variant='bodyMd' fontWeight='medium'>{t("Custom Solutions")}</Text>
        <Tooltip content={t("Available at an additional cost")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
      </InlineStack>,
      enhanced: "-",
      premium: activeMajor,
      elite: activeMajor,
      withTooltip: true
    },
    {
      id: '13',
      services: t("Priority for Feature Requests"),
      enhanced: activeMajor,
      premium: t("Yes (Medium Priority)"),
      elite: t("Yes (Highest Priority)")
    },
    {
      id: '14',
      services: t("Peak Season Support"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '15',
      services: <InlineStack gap={"050"}>
        <Text as='span' variant='bodyMd' fontWeight='medium'>{t("Dedicated Server Instance")}</Text>
        <Tooltip content={t("Available at an additional cost")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
      </InlineStack>,
      enhanced: "-",
      premium: activeMajor,
      elite: activeMajor,
      withTooltip: true
    },
    {
      id: '16',
      services: t("Monthly Performance Review"),
      enhanced: activeMajor,
      premium: activeMajor,
      elite: activeMajor
    },
    {
      id: '17',
      services: t("Marketing POC"),
      enhanced: "-",
      premium: "-",
      elite: activeMajor
    },
    {
      id: '18',
      services: t("Dedicated Amazon POC"),
      enhanced: "-",
      premium: "-",
      elite: activeMajor
    },
    {
      id: '19',
      services: <></>,
      enhanced: <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M")} >{t("Contact Us")}</Button>,
      premium: <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M")} >{t("Contact Us")}</Button>,
      elite: <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M")} >{t("Contact Us")}</Button>,
    }
  ];

  const rowMarkup = marketingServicesData.map(
    (
      { id, services, enhanced, premium, elite, withTooltip },
      index,
    ) => (
      <IndexTable.Row id={id} key={id} position={index}>
        <IndexTable.Cell>
          {withTooltip ? services : <Text variant="bodyMd" fontWeight="medium" as="span">
            {services}
          </Text>}
        </IndexTable.Cell>
        <IndexTable.Cell><div className='text-align-center'>{enhanced}</div></IndexTable.Cell>
        <IndexTable.Cell><div className='text-align-center'>{premium}</div></IndexTable.Cell>
        <IndexTable.Cell><div className='text-align-center'>{elite}</div></IndexTable.Cell>
      </IndexTable.Row>
    ),
  );
  return (
    <div className='custom-marketing-comparison-table'>
      <LegacyCard>
        <IndexTable
          itemCount={marketingServicesData.length}
          headings={[
            { title: t("Services"), alignment: "start" },
            { title: t('Enhanced'), alignment: "center" },
            { title: t('Premium'), alignment: "center" },
            { title: t('Elite'), alignment: "center" },
          ]}
          selectable={false}
        >
          {rowMarkup}
        </IndexTable>
      </LegacyCard>
    </div>
  )
}

export default MarketingComparison;